import styled from 'styled-components';
import { FADE, t } from 'theme';

const Title = styled.div`
  font-weight: bold;
  position: absolute;
  top: -12px;
  &:after {
    background-color: ${t('panel')};
    transition: background-color ${FADE};
    bottom: 32%;
    content: ' ';
    height: 5px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: -1;
  }
`;

const Description = styled.div`
  position: relative;
  min-height: 100px;
  ${props => props.isCombat && 'min-height: 0px; margin-bottom: 1rem;'}
  text-align: left;
  > div {
    padding-bottom: 20px;
    .dialogue {
      font-style: italic;
    }
  }
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

/**
 * The panel was position:absolute with only a `top`, so it fell wherever its static position
 * in the grid put it — over the notification log, and moving whenever the layout changed. It
 * is centred in the viewport now: fixed, inset:0, margin:auto, which centres on both axes
 * without a transform, so the scrim below can stay a plain fixed overlay (a transformed
 * ancestor would make position:fixed resolve against the panel instead of the viewport).
 */
const Panel = styled.div`
  background: ${t('panel')};
  color: ${t('fg')};
  transition: background-color ${FADE}, color ${FADE};
  padding: 20px;
  position: fixed;
  inset: 0;
  margin: auto;
  width: 335px;
  ${props => props.isCombat && 'width: 400px;'}
  /* No overflow clipping here: the Title sits at top:-12px so it straddles the panel's edge,
     and the :after border is offset by -2px. Both get cut off the moment this scrolls. */
  height: fit-content;
  z-index: 20;
  /* The wash and the frame are pseudo-elements, so the Panel's own transition does not reach
     them — an event opened mid-crossover used to fade its face while its border and scrim
     arrived already in the other palette. They get the same clock. */
  &:before {
    background-color: ${t('scrim')};
    transition: background-color ${FADE};
    content: ' ';
    position: fixed;
    inset: 0;
    z-index: -2;
  }
  &:after {
    position: absolute;
    top: -2px;
    left: -2px;
    width: 100%;
    height: 100%;
    content: ' ';
    border: 2px solid ${t('panelBorder')};
    box-shadow: 5px 5px 5px ${t('panelShadow')};
    transition: border-color ${FADE}, box-shadow ${FADE};
    z-index: -2;
  }
`;

const Button = styled.div`
  float: left;
  margin-right: 20px;
`;

export { Button, Buttons, Description, Panel, Title };
